import React from "react";
import { Purchase } from "../../data/purchase";
import { Card } from "../ui/Card";
import { Button } from "../ui/Button";
import { Icon } from "../ui/Icon";
import { plan2plateIcons } from "../../utils/iconUtils";
import { formatPurchaseDescription } from "../../utils/purchaseUtils";
import { SectionLabel } from "../ui/SectionLabel";
import { AddDashedButton } from "../ui/AddDashedButton";
import { Glyph } from "../SmallIconButton";
import { cn } from "../../lib/utils";

export function FoodPurchasesCard({
  purchases,
  onEdit,
  onAdd,
}: {
  purchases: Purchase[];
  onEdit?: (purchaseId: number) => void;
  onAdd: () => void;
}) {
  return (
    <Card className="p-4 flex flex-col gap-3 border-line bg-surface-card">
      <SectionLabel>Marken / Kaufprodukte</SectionLabel>
      {!!purchases.length && (
        <div className="flex flex-col gap-2">
          {purchases.map((purchase) => (
            <div
              key={purchase.id}
              onClick={onEdit ? () => onEdit(purchase.id) : undefined}
              className={cn(
                "p-3 border border-line bg-surface rounded-card text-sm text-ink font-semibold flex justify-between items-center",
                onEdit && "hover:border-teal transition cursor-pointer",
              )}
            >
              <span>{formatPurchaseDescription(purchase)}</span>
              {onEdit && (
                <Icon size={16} tone="muted">
                  {plan2plateIcons.pencil}
                </Icon>
              )}
            </div>
          ))}
        </div>
      )}
      <AddDashedButton onClick={onAdd}>
        <Glyph icon="plus" size={15} />
        Produkt hinzufügen
      </AddDashedButton>
    </Card>
  );
}
